import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { createValidator, required, email } from 'utils/form/validation';
import { reduxForm, Field } from 'redux-form';
import { Form, FormItem, FormGroup, TextInput } from 'components/core/Form';
import { Button } from 'components/core/Button';
import { IconText } from 'components/core/IconText';

import './unsubscribeForm.scss';

const validate = createValidator({
	email: [required, email]
});

export const enhance = compose(
	reduxForm({
		form: 'unsubscribe',
		validate
	})
);

export function UnsubscribeForm({
	error, handleSubmit, invalid, submitting
}) {
	return (
		<Form
			onSubmit={handleSubmit}
			invalid={invalid}
			className="unsubscribe-form"
			successLabel="success-unsubscribe "
			failureLabel="fail-unsubscribe"
			id="unsubscribe-form"
		>
			{!!error &&
				<FormGroup className="error-message">
					<IconText type="alert">
						{error}
					</IconText>
				</FormGroup>
			}
			<FormGroup>
				<FormItem className="email-item" fill>
					<Field
						name="email"
						label="Email address"
						component={TextInput}
						errorMessage="Please provide your email address"
					/>
				</FormItem>
				<FormItem className="submit-item">
					<Button
						type="submit"
						disabled={submitting}
					>
						Unsubscribe
					</Button>
				</FormItem>
			</FormGroup>
		</Form>
	);
}

UnsubscribeForm.propTypes = {
	error: PropTypes.string,
	handleSubmit: PropTypes.func,
	invalid: PropTypes.bool,
	submitting: PropTypes.bool
};

export default enhance(UnsubscribeForm);
